export default "__VITE_ASSET__DNVtOc7i__"